import React from 'react';
import MainContent from '../components/MainContent/MainContent';

const AccueilPage: React.FC = () => {
  return (
    <>
      <div className="container">
        <h2 className="section-title">Le concept : Votre aventure VIP</h2>
        
        <div className="card">
            <h3>🌿 Petit comité (2 à 3 personnes)</h3>
            <p>Vivez une expérience privilégiée. Loin des foules, nous privilégions l'échange et la sérénité pour une immersion totale dans la nature.</p>
        </div>

        <div className="card">
            <h3>🎒 Clef en main & Sur mesure</h3>
            <p>Oubliez la logistique. Nous traçons l'itinéraire selon vos envies. Du point de départ au retour, tout est organisé pour votre confort.</p>
        </div>

        <div className="card">
            <h3>🗺️ Accessible à tous</h3>
            <p>Pas besoin d'être un athlète pour découvrir les trésors de notre région. Nos parcours sont adaptés à votre niveau pour un plaisir garanti.</p>
        </div>

        <div className="highlight-box">
            <strong>"La région comme vous ne l'avez jamais vue, un pas après l'autre."</strong>
        </div>
    </div>
      <MainContent />
    </>
  );
};

export default AccueilPage;